import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { useDictionary } from '@/src/app/hooks';
import type { UnitDTO } from '@/src/ui';

interface LessonNavProps {
    unit: UnitDTO;
    grade: string;
    selectedLesson: number | null;
    setSelectedLesson: (lesson: number | null) => void;
}

const LessonNav: React.FC<LessonNavProps> = ({
    unit,
    grade,
    selectedLesson,
    setSelectedLesson,
}) => {
    const { translate } = useDictionary();
    const navigate = useNavigate();
    const params = useParams();
    const hasUnitParam = !!params.unit;

    const nLessons = unit.lessons?.length || 0;

    function updateSelectedLesson(diff: number) {
        if (selectedLesson === null) {
            return;
        }
        let newLesson = selectedLesson + diff;
        if (newLesson < 0) {
            newLesson = 0;
        }
        if (newLesson >= nLessons) {
            newLesson = nLessons - 1;
        }
        setSelectedLesson(newLesson);
    }
    return (
        <div id="lesson-nav-wrapper">
            <div id="lesson-nav" className="lessonNav">
                <a
                    href="#"
                    id="backToUnitsLink"
                    className="grade-back-link pd-dark text"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (hasUnitParam) {
                            navigate(`/lessons/${grade}`, { replace: true });
                        }
                        setSelectedLesson(null);
                    }}
                >
                    {`< ${translate('Grade')} ${grade} (${translate('Back')})`}
                </a>
                <div className="lesson-link-navigation">
                    <a
                        href="#"
                        id="previousLessonLink"
                        className={`pd-dark text ${selectedLesson === 0 ? ' disabled' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            updateSelectedLesson(-1);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {`< ${translate('Previous Lesson')}`}
                    </a>
                    &nbsp;|&nbsp;
                    <a
                        href="#"
                        id="nextLessonLink"
                        className={`pd-dark text ${selectedLesson === nLessons - 1 ? ' disabled' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            updateSelectedLesson(1);
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        {`${translate('Next Lesson')} >`}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LessonNav;
